import { Draft } from 'immer'
import { factories } from '@opallabs/starman'
import { BFFComponent } from '../../../schema'
import { BlockResponse } from '../types'

type ConnectionIdentifier = { id: string; name: string | null }

type CreateBlockConnectorParams = {
  view: ConnectionIdentifier
  parent_block: ConnectionIdentifier
  category: ConnectionIdentifier | null
}

export const createBlockConnector = ({
  category,
  parent_block,
  view,
}: CreateBlockConnectorParams) => {
  return (draftDocument: Draft<BlockResponse>) => {
    if (!draftDocument.data) return draftDocument

    const blockConnector: BFFComponent<'block_connector'> =
      factories.asgardBff.components.blockConnector.build({
        view,
        parent_block,
        category,
      })

    draftDocument.data.details.connectors.push(blockConnector)

    return draftDocument
  }
}
